import { _ as we } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.to-string-f55666a8.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import { useTheme as Te } from "@ucl/shared-component-foundations";
import { c as v } from "./index-8b07dec9.js";
import { forwardRef as Oe, useRef as te, useState as D, useEffect as re } from "react";
import p, { css as c } from "styled-components";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.array.is-array-7a29277f.js";
import { c as De } from "./combineRefs-c9ad2c39.js";
import { g as Ne } from "./getMetrics-953aa4f8.js";
import { _ as N, f as We } from "./index-f5b44da3.js";
import { a as W } from "./index-5d0f31c6.js";
import "./carousel.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { jsxs as C, jsx as n } from "react/jsx-runtime";
import { InputState as $e, HelperText as Me } from "./helperText.js";
import { Label as ke } from "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { useAccessibilityProps as Re } from "./accessibility.js";
import { uniqueId as He } from "./uniqueId.js";
import { S as io } from "./singleSelectInput-6bdc2a66.js";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./inherit-if-required-f068457b.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./set-species-5ede2ed0.js";
import "./string-trim-14e37ad3.js";
import "./object-to-array-0474b7e7.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./array-method-is-strict-e5a3c878.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./aria.js";
import "./useWindowSize.js";
import "./isClient-2f5bedbd.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./es.array.join-c1bca812.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./index-f2264f1e.js";
import "./iconButton.js";
import "./button.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "@ucl/shared-icons";
import "./screenReaderOnly.js";
import "./getElementPosition-8d0dbc61.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./string-html-forced-a746405b.js";
import "./es.global-this-a7f40ce1.js";
import "./closeButton.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./useMediaQuery.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./tooltip.js";
var je = ["placeholder", "isDisabled", "options", "selected", "onOptionSelect", "onClickClear", "size", "onChange", "onBlur", "inputState", "required", "className", "labelProp", "infoProp", "trailingText", "isSearchable", "tagGroupProp", "noResultText", "helperTextProp", "menuHeader", "exceedOverflow", "maxItems", "menuDirection", "menuWidth", "_csMaskContent"], Be = /* @__PURE__ */ p.div.withConfig({
  displayName: "multiSelectInput__Container",
  componentId: "vauhrm-0"
})(["", ";"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.Container);
}), Ee = /* @__PURE__ */ p.div.withConfig({
  displayName: "multiSelectInput__MultiSelectContainer",
  componentId: "vauhrm-1"
})(["&.multiSelect-mainWrapper{", ";}"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.MultiSelectContainer);
}), Ke = /* @__PURE__ */ p.div.withConfig({
  displayName: "multiSelectInput__Selections",
  componentId: "vauhrm-2"
})(["", ";"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.Selections);
}), qe = /* @__PURE__ */ p.input.withConfig({
  displayName: "multiSelectInput__Search",
  componentId: "vauhrm-3"
})(["&.multiSelect-search{", ";}"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.Search);
}), Le = /* @__PURE__ */ p.button.withConfig({
  displayName: "multiSelectInput__ClearButton",
  componentId: "vauhrm-4"
})(["", ";"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.ClearButton);
}), Ue = /* @__PURE__ */ p.button.withConfig({
  displayName: "multiSelectInput__DropdownIcon",
  componentId: "vauhrm-5"
})(["&.multiSelect-dropdownIcon{", ";}"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.DropdownIcon);
}), ze = /* @__PURE__ */ p.div.withConfig({
  displayName: "multiSelectInput__SearchSectionContainer",
  componentId: "vauhrm-6"
})(["&.multiSelect-searchSectionContainer{", ";}"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.SearchSectionContainer);
}), Fe = /* @__PURE__ */ p.div.withConfig({
  displayName: "multiSelectInput__IconWrapper",
  componentId: "vauhrm-7"
})(["", ";"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.IconWrapper);
}), Ge = /* @__PURE__ */ p.div.withConfig({
  displayName: "multiSelectInput__InputWrapper",
  componentId: "vauhrm-8"
})(["", ";"], function(e) {
  var o = e.theme.components.selectInput;
  return c(o.multiSelectInput.InputWrapper);
}), Ve = "MultiSelect", Ae = function(o, b) {
  var h = o.trim();
  return h = h.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), b.filter(function(s) {
    return ("" + s.label + s.value).search(new RegExp(h, "i")) < 0;
  }).map(function(s) {
    return s.value;
  });
}, ro = /* @__PURE__ */ Oe(function(e, o) {
  var b, h, s, $, M, k, R = e.placeholder, H = R === void 0 ? "Select..." : R, j = e.isDisabled, i = j === void 0 ? !1 : j, P = e.options, y = e.selected, oe = e.onOptionSelect, B = e.onClickClear, E = e.size, S = E === void 0 ? "medium" : E, K = e.onChange, ne = e.onBlur, q = e.inputState, f = q === void 0 ? $e.NONE : q, _ = e.required, L = e.className, ie = L === void 0 ? "" : L, le = e.labelProp, ae = e.infoProp, pe = e.trailingText, U = e.isSearchable, w = U === void 0 ? !0 : U, z = e.tagGroupProp, ce = e.noResultText, ue = e.helperTextProp, F = e.menuHeader, G = e.exceedOverflow, me = G === void 0 ? !1 : G, V = e.maxItems, se = V === void 0 ? 8 : V, A = e.menuDirection, de = A === void 0 ? "down_auto" : A, X = e.menuWidth, he = X === void 0 ? "280px" : X, fe = e._csMaskContent, g = we(e, je), Ie = Ne({
    label: "MultiSelectInput"
  }), u = te(He((b = g.id) != null ? b : Ve)), I = Object.keys(y), m = te(null), J = D(""), T = J[0], Q = J[1], Y = D(!1), a = Y[0], O = Y[1], Z = D([]), Se = Z[0], ve = Z[1], Ce = Te();
  !w && I.length > 0 && (H = "");
  var l = ue, x = {
    defaultId: (l == null || (h = l.defaultProp) == null ? void 0 : h.id) || "default_" + u.current + "_message_id",
    secondaryId: (l == null || (s = l.secondaryProp) == null ? void 0 : s.id) || "secondary_" + u.current + "_message_id"
  };
  re(function() {
    ve(Ae(T, P));
  }, [T, P]), re(function() {
    if (a === !0) {
      var r;
      (r = m.current) == null || r.focus();
    } else
      Q("");
  }, [a]);
  var be = Re("combobox", {
    ariaExpanded: a,
    ariaDisabled: i,
    ariaRequired: _,
    ariaInvalid: f === "caution" || f === "error",
    ariaHasPopup: "listbox",
    ariaControls: "content-" + u.current,
    ariaLabelledBy: u.current + "_label_id " + (l != null && l.defaultProp ? x.defaultId : "") + " " + (l != null && l.secondaryProp ? x.secondaryId : "")
  }), ge = function(t) {
    var d;
    B && B(t), (d = m.current) == null || d.focus();
  }, xe = function(t) {
    var d;
    (d = m.current) == null || d.focus(), t.target === t.currentTarget && O(!a);
  }, Pe = function(t, d) {
    var ee;
    t.preventDefault(), oe(d, t), (ee = m.current) == null || ee.focus(), K && K(t);
  }, ye = function(t) {
    Q(t.target.value);
  }, _e = function() {
    if (m != null && m.current) {
      var t;
      (t = m.current) == null || t.focus();
    }
  };
  return /* @__PURE__ */ C(Be, Object.assign({
    className: ie
  }, g, Ie, {
    children: [/* @__PURE__ */ n(ke, {
      labelProp: Object.assign({
        id: u.current + "_label_id",
        showRequiredIndicator: _,
        htmlFor: g.id || u.current
      }, le),
      infoProp: Object.assign({
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info"
      }, ae),
      trailingText: pe,
      onClick: _e
    }), /* @__PURE__ */ C(N, {
      className: "no-filter",
      menuOpen: !i && a,
      menuHeader: F,
      handleMenuOpen: function(t) {
        return O(t);
      },
      onChange: Pe,
      type: "multiple",
      disableAutoFocus: !0,
      isDisabled: i,
      exceedOverflow: me,
      menuDirection: de,
      uniqueIdentifier: u.current,
      hiddenItems: Se,
      noResultText: ce,
      menuWidth: he,
      maxItems: se,
      _csMaskContent: fe,
      children: [/* @__PURE__ */ n(N.Control, {
        children: /* @__PURE__ */ n(Ee, {
          className: v([["multiSelect-mainWrapper", "multiSelect-mainWrapper--" + S, a && "multiSelect-mainWrapper--isOpen", f && f !== "none" && "multiSelect-mainWrapper--" + f, i && "multiSelect-mainWrapper--disabled"]]),
          onBlur: ne,
          onKeyUp: function(t) {
            t.code === "Space" && t.stopPropagation(), t.code !== "Tab" && (a || O(!0));
          },
          "data-testid": "multiSelect-wrapper",
          children: /* @__PURE__ */ C(ze, {
            className: v([["multiSelect-searchSectionContainer", i && "multiSelect-searchSectionContainer--disabled"]]),
            children: [I.length > 0 && /* @__PURE__ */ n(Ke, {
              onClick: xe,
              "data-testid": "selection-wrapper",
              onKeyDown: function(t) {
                (t.code === "Enter" || t.code === "Space" && i) && (t.preventDefault(), t.stopPropagation());
              },
              children: z ? /* @__PURE__ */ n(We, Object.assign({}, z, {
                children: I.map(function(r) {
                  return y[r];
                })
              })) : I.map(function(r) {
                return y[r];
              })
            }), /* @__PURE__ */ C(Ge, {
              children: [/* @__PURE__ */ n(qe, Object.assign({
                id: "control-" + u.current,
                disabled: i,
                placeholder: H,
                onChange: ye,
                value: T,
                size: S,
                ref: De(o, m),
                required: _,
                className: v([["multiSelect-search", "multiSelect-search--" + S, a && "multiSelect-search--isOpen", i && "multiSelect-search--disabled", w && a && "multiSelect-search--cursor-text"]]),
                "data-testid": "search-input-test-id",
                onKeyDownCapture: function(t) {
                  t.code === "Enter" && (t.preventDefault(), t.stopPropagation());
                },
                readOnly: !w || F === "local_search"
              }, g, be)), /* @__PURE__ */ C(Fe, {
                children: [I.length > 0 && !i && /* @__PURE__ */ n(Le, {
                  onClick: ge,
                  disabled: i,
                  className: v(["IconWrapper", S !== "small" && "IconWrapper--offset"]),
                  "aria-label": "clear",
                  children: /* @__PURE__ */ n(W, Object.assign({
                    icon: "cancelCloseFilled"
                  }, Ce.components.selectInput.multiSelectInput.InlineStyles.closeButtonStyle))
                }), /* @__PURE__ */ n(Ue, {
                  "aria-label": "dropdown",
                  onKeyUp: function(t) {
                    i && t.stopPropagation();
                  },
                  tabIndex: -1,
                  "data-testid": "dropdown-test-id",
                  className: v([["multiSelect-dropdownIcon", "multiSelect-dropdownIcon--" + S, i && "multiSelect-dropdownIcon--disabled"]]),
                  children: a ? /* @__PURE__ */ n(W, {
                    icon: "caretUp"
                  }) : /* @__PURE__ */ n(W, {
                    icon: "caretDown"
                  })
                })]
              })]
            })]
          })
        })
      }), P.map(function(r) {
        return /* @__PURE__ */ n(N.Item, {
          id: r.value,
          isSelected: !!I.includes(r.value),
          label: r.label,
          value: r.value,
          description: r.description,
          disabled: r.disabled
        }, r.value);
      })]
    }), /* @__PURE__ */ n(Me, {
      secondaryProp: {
        id: x.secondaryId,
        helperText: l == null || ($ = l.secondaryProp) == null ? void 0 : $.helperText
      },
      inputState: f,
      defaultProp: {
        id: x.defaultId,
        helperText: (M = l == null || (k = l.defaultProp) == null ? void 0 : k.helperText) != null ? M : ""
      }
    })]
  }));
});
export {
  ro as MultiSelectInput,
  io as SingleSelectInput
};
